import React from 'react';
import { Link } from 'gatsby';

import Html from 'views/components/html';
import Header from 'views/components/header';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Breadcrumb from 'views/components/breadcrumb';
import RightTriangle from 'views/components/right-triangle';
import BackToTopButton from 'views/components/back-to-top-button';
import Footer from 'views/components/footer';
import { Background, Heading, List, Thumbnails, Machines, EastFactory, CleanRoom } from './index.styled';
import title from './assets/title.gif';
import is220gn from './assets/IS220GN.jpg';
import ec160n2 from './assets/EC160N2.jpg';
import ec40 from './assets/EC40.jpg';
import ec100n2 from './assets/EC100N2.jpg';
import s2000i100b from './assets/S-2000i100B.jpg';
import eastFactory from './assets/east-factory.jpg';
import cleanRoom from './assets/cleanroom.jpg';

const Equipment = () => {
  return (
    <>
      <Html title="設備" />
      <Header />
      <Body>
        <Contents>
          <Breadcrumb><Link to="/">HOME</Link>　&gt;　設備</Breadcrumb>
          <Background>
            <Heading>
              <h1><img src={title} alt="設備" /></h1>
            </Heading>
            <Machines>
              <h2>成形機</h2>
              <List>
                <table>
                  <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>メーカー</th>
                    <th colSpan={2}>機種</th>
                    <th>台数</th>
                    <th colSpan={2}>特徴</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>本社工場</td>
                    <td>日精樹脂</td>
                    <td>FN5000</td>
                    <td>220t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>ES600</td>
                    <td>60t</td>
                    <td>2</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>東芝機械</td>
                    <td>IS220GN</td>
                    <td>220t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>IS130GN</td>
                    <td>130t</td>
                    <td>2</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>IS100GN</td>
                    <td>100t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC160NII</td>
                    <td>160t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>高速仕様</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC160C</td>
                    <td>160t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>LCP専用機</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC100N</td>
                    <td>100t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC100</td>
                    <td>100t</td>
                    <td>2</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC40</td>
                    <td>40t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>東工場</td>
                    <td>日精樹脂</td>
                    <td>ES600</td>
                    <td>60t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>ES400</td>
                    <td>40t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>東芝機械</td>
                    <td>IS170GN</td>
                    <td>170t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>IS130GN</td>
                    <td>130t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>IS80GN</td>
                    <td>80t</td>
                    <td>1</td>
                    <td>油圧機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC220C</td>
                    <td>220t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>EC60NII</td>
                    <td>60t</td>
                    <td>1</td>
                    <td>電動機</td>
                    <td>高速仕様</td>
                  </tr>
                  <tr>
                    <td>クリーンルーム</td>
                    <td>東芝機械</td>
                    <td>EC100NII</td>
                    <td>100t</td>
                    <td>2</td>
                    <td>電動機</td>
                    <td>高速仕様</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>ファナック</td>
                    <td>S-2000i100B</td>
                    <td>100t</td>
                    <td>2</td>
                    <td>電動機</td>
                    <td>高速仕様</td>
                  </tr>
                  </tbody>
                </table>
              </List>
              <Thumbnails>
                <p><RightTriangle />IS220GN</p>
                <img src={is220gn} alt="IS220GN" />
                <p><RightTriangle />EC160NII</p>
                <img src={ec160n2} alt="EC160NII" />
                <p><RightTriangle />EC40</p>
                <img src={ec40} alt="EC40" />
                <p><RightTriangle />EC100NII</p>
                <img src={ec100n2} alt="EC100NII" />
                <p><RightTriangle />S-2000i100B</p>
                <img src={s2000i100b} alt="S-2000i100B" />
              </Thumbnails>
            </Machines>
            <EastFactory>
              <h2>東工場</h2>
              <img src={eastFactory} alt="東工場" />
              <p>平成15年2月　増設</p>
            </EastFactory>
            <CleanRoom>
              <h2>クリーンルーム（東工場2F）</h2>
              <img src={cleanRoom} alt="クリーンルーム" />
              <p>クラス10.000のクリーンルーム</p>
            </CleanRoom>
          </Background>
          <BackToTopButton />
        </Contents>
      </Body>
      <Footer />
    </>
  );
};

export default Equipment;
